
import { STORAGE_KEYS } from '@constants';

export const getDashboardRoute = () => {
  try {
    const companyStr = localStorage.getItem(STORAGE_KEYS.COMPANY_DATA);
    if (companyStr) {
      const company = JSON.parse(companyStr);
      if (company?.role === 'manufacturer') return '/mfg-dashboard';
      if (company?.role === 'distributor') return '/tally-dashboard-v2';
    }
  } catch (e) {
    console.error('Error determining dashboard route:', e);
  }
  return '/financial-dashboard';
};


export const isOnboardingComplete = (user) => {
  if (!user) return false;
  const hasCompany = !!(user.company_id);
  const hasRole = !!(user.role_id || user.company_role_id);
  return hasCompany && hasRole;
};


export const getNextOnboardingStep = (user) => {
  if (!user) {
    return '/login';
  }

  if (isOnboardingComplete(user)) {
    return getDashboardRoute();
  }

  return '/onboarding/role';
};


export const isAuthenticated = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const user = localStorage.getItem(STORAGE_KEYS.USER_DATA);
  return !!(token && user);
};


export const getCurrentUserFromStorage = () => {
  try {
    const userStr = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
};


export const clearAuthData = () => {
  localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_DATA);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem('selectedRole');
};